import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Support from '../../../shared/components/features/support/Support';
import UserProfile from '../../../shared/components/features/userProfile/UserProfile';
import logo from '../../../assests/logo.png'
import Icon from '../../../shared/components/ui/icons/Icon';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import ChangeSchool from '../changeSchool/ChangeSchool';
import classes from './Header.module.css';

const Header = () => {

    const { texts, lang } = useSelector(state => state.translate);
    const { user, userDetails } = useSelector(state => state.auth);
    const accessibilityLink = useSelector(state => state?.uiData?.general?.accessibilityLink)
    const schools = useMemo(() => userDetails?.schools, [userDetails]);

    return (
        <div className={classes.Header}>
            <div className={classes.Text}>
                <img src={logo} alt='logo' />
                <p className={classes.Title}>{texts.virtualSchool}
                    <span className={classes.SchoolName}> - {userDetails?.defaultSchool?.name}</span>
                </p>
            </div>

            <div className={classes.UserName}>
                <Support />
                <Icon name={iconsList.accessibility} size="26px" color="#979797" className={classes.linkIcon} accessibilityDescription={texts.accessibilityStatementLink} onClick={() => window.open(accessibilityLink?.[lang], '_blank', 'noopener,noreferrer')} />
                {schools?.length > 1 &&
                    <div className={classes.Schools}>
                        <ChangeSchool />
                    </div>
                }
                <p className={classes.helloForUser}>{texts.hello} {user?.name} </p>
                <div className={classes.UserProfile}>
                    <UserProfile />
                </div>
            </div>
        </div>
    )
}
export default Header;